export enum LanguageCode {
  CaEs = 'ca-es',
  DaDk = 'da-dk',
  DeAt = 'de-at',
  DeCh = 'de-ch',
  DeDe = 'de-de',
  EnAu = 'en-au',
  EnGb = 'en-gb',
  EnIn = 'en-in',
  EsAr = 'es-ar',
  EsEs = 'es-es',
  EsMx = 'es-mx',
  FrBe = 'fr-be',
  FrFr = 'fr-fr',
  ItIt = 'it-it',
  NlBe = 'nl-be',
  NlNl = 'nl-nl',
  PlPl = 'pl-pl',
  PtBr = 'pt-br',
  PtPt = 'pt-pt',
  SvSe = 'sv-se',
  TrTr = 'tr-tr',
  ZhCn = 'zh-cn',
}

export const defaultLocale = LanguageCode.EnGb;

export const supportedLocales: Record<LanguageCode, string> = {
  'ca-es': 'Catalan (CA)',
  'da-dk': 'Dansk',
  'de-de': 'Deutsch',
  'de-at': 'Deutsch (AT)',
  'de-ch': 'Deutsch (CH)',
  'en-gb': 'English',
  'en-au': 'English (AU)',
  'en-in': 'English (IN)',
  'es-es': 'Español',
  'es-ar': 'Español (AR)',
  'es-mx': 'Español (MX)',
  'fr-fr': 'Français',
  'fr-be': 'Français (BE)',
  'it-it': 'Italiano',
  'nl-nl': 'Nederlands',
  'nl-be': 'Nederlands (BE)',
  'pl-pl': 'Polski',
  'pt-pt': 'Português',
  'pt-br': 'Português (BR)',
  'sv-se': 'Svenska',
  'tr-tr': 'Türkçe',
  'zh-cn': '中文 (简体)',
};
